import { request } from './repository';

const url = 'services/';

const serviceRepository = {
    getPersonServices(id, params = {}) {
        return request.get(url + `person/${id}`, params);
    },
    getService(id, params = {}) {
        return request.get(url + id, params);
    },
    getServicesForMultipleExecution(body, params) {
        return request.post('multiple/services', body, params);
    },
    getServicesInbox(params) {
        return request.get('services-inbox', params);
    },
    getServicesOutbox(params) {
        return request.get('services-outbox', params);
    },
    getServicesInboxCount() {
        return request.get('total-services-in-progress');
    },
    storeService(data) {
        if(data.person_id){
            data = _.pick(data, ['person_id', 'address', 'questionnaire_answers', 'observation', 'identifiable_person', 'source_service_id', 'source_service_priority_id', 'execute_first_procedure', 'attendance_channel_id', 'same_address_as_person', 'support_ticket_id'])
        }
        return request.post(url, data);
    },
    updateService(id, data) {
        return request.put(url + id, data);
    },
    cancelService(id, data) {
        return request.post('cancel-service/' + id, data);
    },
    fetchDuplicatedServices(params) {
        return request.get('duplicated-services', params);
    },
    showDuplicatedServices(data) {
        return request.post('duplicated-services/services', data);
    },
    changeService(id, data) {
        return request.post('service/' + id + '/move', data);
    }
}

export default serviceRepository;
